import React from 'react';
import ReactDOM from 'react-dom';
import ScheduleDay from 'components/ScheduleDay.js';

export default class ScheduleWeekBlock extends React.Component {
  constructor(props) {
    super(props);

    this.weekDiv = null;
    this.filteredWeekData = this.getDefaultFilteredWeek();
    this.currentWeek = '';
    this.currentWeekDayRange = '';
    this.weekCount = 0;

    this.state = {
      domSet: this.props.domSet != 'false',
      parsed: false,
      filteredWeekData: {},
    };
  }

  componentDidMount() {
    this.weekDiv = ReactDOM.findDOMNode(this);
  }

  componentDidUpdate() {
    this.filteredWeekData = this.getDefaultFilteredWeek();

    this.state = {
      domSet: this.props.domSet != 'false',
      parsed: false,
      filteredWeekData: {},
    };
    if (
      this.state.domSet == false
      && this.state.parsed == false
      && _.isEmpty(this.filteredWeekData.scheduledShifts)
    ) {
      this.parseWeekData();
    }
  }

  getDefaultFilteredWeek() {
    return {
      scheduledShifts: {},
      offeredShifts: {},
      availableShifts: {},
      unavailableShifts: {},
      unavailableRequests: {},
      availableExchanges: {},
    };
  }

  parseWeekData() {
    const that = this;
    that.currentWeek = document.querySelectorAll('.month .week')[
      this.weekDiv.getAttribute('id').split('week')[1] - 1
    ];
    that.currentWeekDayRange = that.currentWeek.getAttribute('data-day-range');
    that.filteredWeekData = that.getDefaultFilteredWeek();
    if (!Utils.isNotDefined(that.currentWeekDayRange)) {
      const rangeSplit = that.currentWeekDayRange.split('-');
      const weekStart = parseInt(rangeSplit[0]);
      const weekEnd = parseInt(rangeSplit[1]);

      let count = weekStart;
      this.weekCount = Math.ceil(count / 7) + 1;
      while (count <= weekEnd) {
        if (this.props.allShiftActivity.shiftData !== null) {
          var filter = _.filter(
            this.props.allShiftActivity.shiftData,
            data => parseInt(moment(data.date).format('D')) == parseInt(count),
          );

          if (filter.length > 0) {
            that.filteredWeekData.scheduledShifts[count] = filter;
          }
        }
        if (this.props.allShiftActivity.offeredShifts !== null) {
          var filter = _.filter(
            this.props.allShiftActivity.offeredShifts,
            data => parseInt(
              moment(data.start_time)
                .tz(data.time_zone)
                .format('D'),
            ) == parseInt(count),
          );

          if (filter.length > 0) {
            that.filteredWeekData.offeredShifts[count] = filter;
          }
        }

        if (this.props.allShiftActivity.availableData !== null) {
          var filter = _.filter(this.props.allShiftActivity.availableData, (data) => {
            // var day = new Date(data.starts_at * 1000).getDate();
            const momentDay = moment
              .tz(moment.unix(data.starts_at), Utils.getCoreUser().inferred_time_zone)
              .format('D');
            return parseInt(momentDay) == parseInt(count);
          });

          if (filter.length > 0) {
            that.filteredWeekData.availableShifts[String(count)] = filter;
          }
        }

        if (this.props.allShiftActivity.unavailableData !== null) {
          var filter = _.filter(
            this.props.allShiftActivity.unavailableData,
            data => parseInt(moment(data.date).format('D')) == parseInt(count),
          );

          if (filter.length > 0) {
            that.filteredWeekData.unavailableShifts[String(count)] = filter;
          }
        }

        if (this.props.allShiftActivity.unavailableRequests !== null) {
          var filter = _.filter(
            this.props.allShiftActivity.unavailableRequests,
            data => parseInt(moment(data.date).format('D')) == parseInt(count),
          );

          if (filter.length > 0) {
            that.filteredWeekData.unavailableRequests[count] = filter;
          }
        }

        if (this.props.allShiftActivity.availableExchanges !== null) {
          var filter = _.filter(
            this.props.allShiftActivity.availableExchanges,
            data => parseInt(
              moment(data.shift_details.start_time)
                .tz(data.shift_details.time_zone)
                .format('D'),
            ) == parseInt(count), // && data.state !== 'accepted';
          );

          if (filter.length > 0) {
            filter = this.addUserToExchange(filter);
            that.filteredWeekData.availableExchanges[count] = filter;
          }
        }

        count++;
      }
    }
    this.state.domSet = true;
  }

  parseDayData(data, day) {
    const rtnObj = {};
    if (data.scheduledShifts.hasOwnProperty(day)) rtnObj.scheduledShifts = data.scheduledShifts[day];
    if (data.offeredShifts.hasOwnProperty(day)) rtnObj.offeredShifts = data.offeredShifts[day];
    if (data.availableShifts.hasOwnProperty(day)) rtnObj.availableShifts = data.availableShifts[day];
    if (data.unavailableShifts.hasOwnProperty(day)) rtnObj.unavailableShifts = data.unavailableShifts[day];
    if (data.unavailableRequests.hasOwnProperty(day)) rtnObj.unavailableRequests = data.unavailableRequests[day];
    if (data.availableExchanges.hasOwnProperty(day)) rtnObj.availableExchanges = data.availableExchanges[day];

    return rtnObj;
  }

  addUserToExchange(data) {
    const users = this.props.allShiftActivity.availableExchangeUsers;
    const len = data.length;
    for (let i = 0; i < len; i++) {
      const userID = data[i].user_id;
      const userData = ExchangesStore.getExchangeUser(userID);
      data[i].user_name = userData.name;
    }
    return data;
  }

  render() {
    const block = [];
    let count = 0;
    let weekStart;
    let weekEnd;
    if (this.state.domSet == true && this.state.parsed == false) {
      this.parseWeekData();

      if (this.currentWeekDayRange != null) {
        const rangeSplit = this.currentWeekDayRange.split('-');
        weekStart = parseInt(rangeSplit[0]);
        weekEnd = parseInt(rangeSplit[1]);
        count = weekStart;
      }
    }

    if (count != -1) {
      // 0 based index week length
      const weekLengthIndex = 6;

      // offset length of previous month days in current month view.
      // 6th calendar cell minus monthStartOffset of 2 equals 4th day.
      let monthStartOffset = weekLengthIndex - (weekEnd - weekStart);
      if (weekStart != 1) {
        monthStartOffset = 0;
      }

      for (let i = 0; i <= weekLengthIndex; i++) {
        const currentDayData = this.parseDayData(this.filteredWeekData, count - monthStartOffset);
        block.push(
          <ScheduleDay
            key={i}
            weekCount={this.weekCount}
            selectedShift={this.props.selectedShift}
            clearSelectedShiftId={this.props.clearSelectedShiftId}
            selectedExchangeShift={this.props.selectedExchangeShift}
            dayShiftData={currentDayData}
            onDaySelect={this.props.onDaySelect}
            domSet="false"
            monthState="current"
            exchangeDaySelectMode={this.props.exchangeDaySelectMode}
            selectedExchangeDays={this.props.allShiftActivity.selectedExchangeDays}
            removeSelectedDay={this.props.removeSelectedDay}
          />,
        );
        count++;
      }
    }
    const weekID = `week${this.props.week}`;
    return (
      <div className="week" id={weekID}>
        {block}
      </div>
    );
  }
}
